// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'f7d0eda431691460654bcd5879894b1e1628d88b';
export const BUILD_NUMBER = '252';
export const BUILD_TIMESTAMP = '2026-09-28T01:49:41.440Z';
